<template>
  <div v-if="visible">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="px-3">Register Card</v-card-title>
        <v-divider></v-divider>

        <v-container fluid>
          <v-row>
            <!-- Address 1 -->
            <v-col md="6" class="pb-0">
              <v-text-field
                v-model="card.address1"
                :rules="rules.required"
                required
                dense
                label="1st Line Address"
              ></v-text-field>
            </v-col>

            <!-- Postcode -->
            <v-col md="6" class="pb-0">
              <v-text-field
                v-model="card.postcode"
                :rules="rules.required"
                required
                dense
                label="Postcode"
              ></v-text-field>
            </v-col>

            <v-col md="12" class="py-0">
              <v-row>
                <v-col md="12" class="py-0">
                  <CNPForm
                    v-if="rerenderForm > 0"
                    :url="url"
                    :entityId="channels.motoChannel"
                    :currency="channels.currency"
                    :client="client"
                    :card="card"
                    :key="rerenderForm"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="$emit('close', false)"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import CNPForm from './RegisterCardCNPForm.vue';
import debounce from 'lodash.debounce';
export default {
  components: {
    CNPForm
  },
  props: {
    visible: Boolean,
    client: Object,
    channels: Object,
  },
  computed: {
    isVisible(){
        return this.visible
    },
  },
  directives: { mask },
  data() {
    return {
      url: window.location.href,
      rules: { required: [(v) => !!v || "Required"] },
      card: { address1: null, postcode: null },
      errors: [],
      rerenderForm: 0,
      dialog: true,
    };
  },
  watch: {
    card: {
        deep: true,
        handler(){
            this.debouncedWatch()
        }
    }
  },
  created(){
    this.debouncedWatch = debounce(() => {
      this.rerenderForm++
    }, 500);
  },
  beforeMount() {
    this.card.address1 = this.client.street1;
    this.card.postcode = this.client.postcode;
    this.rerenderForm++;
  },
};
</script>

<style scoped>

  ::v-deep .card-items {
    font-family: "Courier New", Courier, monospace;
    font-weight: 600;
    fill: #fff;
  }

  ::v-deep #svg {
    background: url("../../assets/tp-card-3.png") no-repeat #fafafa;
    background-size: 100%;
  }

  ::v-deep #svg-visa {
    background: url("../../assets/tp-card-blank-visa.png") no-repeat;
    background-size: 100%;
  }

  ::v-deep #svg-mastercard {
    background: url("../../assets/tp-card-blank-mastercard.png") no-repeat;
    background-size: 100%;
  }

  ::v-deep #svg-amex {
    background: url("../../assets/tp-card-blank-amex.png") no-repeat;
    background-size: 100%;
  }

  ::v-deep #svg-blank {
    background: url("../../assets/tp-card-blank.png") no-repeat;
    background-size: 100%;
  }

  ::v-deep #threeDsContainer {
    display: block;
    background: #fafafa;
    border: none;
    height: 100vh;
    width: 100%;
  }

  ::v-deep #threeDsContainer body {
    color: #fafafa;
    font-size: 0px;
  }

  ::v-deep .wpwl-form {
    margin: 0 !important;
    max-width: 100% !important;
  }

  ::v-deep .wpwl-control {
    border: none !important;
    background-color: inherit !important;
    color: #000 !important;
  }

  ::v-deep .wpwl-group-brand {
    display: none !important;
  }

  ::v-deep .wpwl-has-error ~ .wpwl-hint {
    color: #ff5252 !important;
    margin: 0;
    font-size: 12px;
    display: none;
  }

  ::v-deep .wpwl-container .v-messages__wrapper {
    color: #ff5252 !important;
    height: 18px !important;
  }

  ::v-deep .wpwl-group {
    margin-bottom: 0 !important;
  }

  ::v-deep #card-cvv-slot {
    margin-top: -2px !important;
  }

  ::v-deep #expiry-slot {
    margin-top: 2px !important;
  }

  ::v-deep .wpwl-wrapper {
    width: 100% !important;
  }
</style>